<template>
  <div
    class="questionMap-container"
    :class="
      animation
        ? ['questionMapContainerTrue', 'questionMapHideAnimation']
        : ['questionMapContainerFalse', 'questionMapUnHideAnimation']
    "
  >
    <div
      class="questionMap mapArea"
      :class="
        animation ? 'questionMapHideAnimation' : 'questionMapUnHideAnimation'
      "
    >
      <Map
        v-if="mcqs.questions.length > 0"
        :mcqs="mcqs"
        name="Multiple Choice Questions"
        :selected="currentSection === 'mcqs'"
        @changeSection="changeSection"
        @changeCurrent="changeCurrent"
      ></Map>
      <Map
        v-if="prog.questions.length > 0"
        :mcqs="prog"
        name="Programming"
        :selected="currentSection === 'Programming'"
        @changeSection="changeSection"
        @changeCurrent="changeCurrent"
      ></Map>
      <Map
        v-if="sub.questions.length > 0"
        :mcqs="sub"
        name="Subjective"
        :selected="currentSection === 'Subjective'"
        @changeSection="changeSection"
        @changeCurrent="changeCurrent"
      ></Map>
      <div style="margin-top: auto;">
        <div class="color-codes">
          <span style="font-weight: bold">QUESTION STATUS</span>
          <div
            v-for="i in 5"
            :key="i"
            style="margin-top:9px;display: flex;align-items: center"
          >
            <div
              v-if="i != 2"
              class="dot"
              :style="{ 'background-color': colors[i - 1] }"
            ></div>
            <div
              v-if="i == 2"
              class="dot"
              :style="{
                'background-color': colors[i - 1],
                border: '1px solid #18202f',
              }"
            ></div>
            <div v-if="i == 3" class="smaller-dot"></div>
            <span style="vertical-align: top; margin-left: 8px;">
              {{ color_desc[i - 1] }}
            </span>
          </div>
        </div>
        <div class="help-and-support">
          <p id="help-support" style="margin: 16px 0 8px 0">Help and Support</p>
          <div id="contact-administrator">
            <p>
              Drop an email at <br /><a style="color: #319BF5"
                >headstart-support@infocusp.com</a
              >
            </p>
            <!--<p>
              OR call us at
              <b
                >Akash: +91-9428801002, Dhaval: +91-7874202989 or Amit:
                +91-9824888628</b
              >
            </p>
            <p>
              OR
              <a
                href="https://meet.google.com/kbg-qghf-ody"
                target="_blank"
                style="color: #319BF5"
                >Join this link</a
              >
              to get help on video call
            </p>-->
          </div>
        </div>
      </div>
    </div>
    <img
      v-if="!hide"
      src="../assets/Collapse.svg"
      class="hideMap unHideImage"
      :class="hide ? 'hideMapTrue' : 'hideMapFalse'"
      @click="animation = !animation"
    />
    <img
      v-else
      src="../assets/Expand.svg"
      class="hideMap hideImage"
      :class="hide ? 'hideMapTrue' : 'hideMapFalse'"
      @click="animation = !animation"
    />
  </div>
</template>

<script>
import Map from './Map'
export default {
  name: 'QuestionMap',
  components: { Map },
  props: ['mcqs', 'prog', 'sub', 'currentSection'],
  data: function() {
    return {
      animation: false,
      colors: ['#FFFFFF', '#FFFFFF', '#ffd600', '#ffd600', '#1BC09C'],
      color_desc: [
        'Unattempted',
        'Current Question',
        '"Answered" and Marked For Review',
        '"Unanswered" and Marked For Review',
        '"Answered"',
      ],
    }
  },
  computed: {
    hide() {
      return this.animation
    },
  },
  methods: {
    changeSection: function(name) {
      this.$emit('changeSection', name)
    },
    changeCurrent(newCurrent) {
      this.$emit('changeCurrent', newCurrent)
    },
  },
}
</script>

<style scoped>
.questionMap-container {
  background-color: white;
  border-right: 1px solid #a8b2c6;
  display: flex;
  flex: 1;
  flex-direction: row;
}
.dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
}
.smaller-dot {
  border-radius: 50%;
  height: 5px;
  width: 5px;
  display: inline-block;
  background-color: #4caf50;
  margin-left: -3px;
  margin-bottom: 5px;
}
.color-codes {
  padding: 16px 8px 40px 8px;
  font-family: Roboto-Regular;
  font-size: 12px;
  color: #9b9b9b;
  background: rgba(9, 136, 244, 0.1);
}
.hr {
  border: 1px solid #efeef3;
}
.mapArea {
  overflow: hidden;
  width: 256px;
  padding-top: 43px;
}
.hideMap {
  cursor: pointer;
  margin: auto;
  display: flex;
  align-items: center;
  width: 16px;
  height: 50px;
}
.hideMapTrue {
  margin-right: 4px;
}
.hideMapFalse {
  margin-left: -16px;
}
.questionMap {
  width: 256px;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
}
.questionMapTrue {
  background: rgba(168, 178, 198, 0.5);
}
.questionMapFalse {
  background: #ffffff;
}
.questionMapContainerTrue {
  background: rgba(168, 178, 198, 0.5);
}
.questionMapHideAnimation {
  animation-name: hideAni;
  animation-duration: 0.5s;
  animation-iteration-count: 1;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
}
@keyframes hideAni {
  0% {
    width: 256px;
  }
  100% {
    width: 20px;
  }
}
.questionMapContainerFalse {
  background: #ffffff;
}
.questionMapUnHideAnimation {
  animation-name: UnhideAni;
  animation-duration: 0.5s;
  animation-iteration-count: 1;
  animation-timing-function: ease-in-out;
}
@keyframes UnhideAni {
  0% {
    width: 20px;
  }
  100% {
    width: 256px;
  }
}
.unHideImage {
  animation-name: UnhideImageAni;
  animation-duration: inherit;
  animation-iteration-count: inherit;
  animation-timing-function: inherit;
}
@keyframes UnhideImageAni {
  0% {
    margin-right: 0px;
  }
  100% {
    margin-left: -16px;
  }
}
.hideImage {
  animation-name: hideImageAni;
  animation-duration: inherit;
  animation-iteration-count: inherit;
  animation-timing-function: inherit;
}
@keyframes hideImageAni {
  0% {
    margin-right: -16px;
  }
  100% {
    margin-right: 20px;
  }
}
.hideMapTrue {
  margin-right: 4px;
}
.hideMapFalse {
  margin-left: -16px;
}
.help-and-support {
  margin-top: 8px;
  font-size: 12px;
  padding: 0 8px;
}
#help-support {
  color: #616262;
  letter-spacing: 0;
  font-family: Roboto-Bold;
  color: #616262;
  letter-spacing: 0;
}
#contact-administrator {
  font-family: Roboto-Regular;
  color: #9b9b9b;
  line-height: 20px;
}
@media only screen and (max-width: 1440px) {
  #help-support {
    margin: 14px 0 8px 0;
  }
  #contact-administrator {
    margin-top: 8px;
  }
}
</style>
